export default __webpack_public_path__ + "static/media/quotation.64bca11e.svg";